import React from 'react';
import { motion, useAnimation } from 'framer-motion';
import { useSelector } from 'react-redux';

import DraftsIcon from '@material-ui/icons/Drafts';
import IconButton from '@material-ui/core/IconButton';


import {
  AnimationContainer,
  MessageContent,
  MessageTitle,
  MessageDate,
  ListContent,
} from './styles';


import axios from '../../config/axiosInstance';


export default function ({ notification, verifyRead, isRead }) {
  const parentControls = useAnimation();
  const childrenControls = useAnimation();
  const [inHover, setHover] = React.useState(false);


  const auth = useSelector(state => state.auth);


  const markAsRead = async (item) => {
    await childrenControls.start({
      opacity: 1,
      zIndex: 1,
      transition: { duration: 0.6 },
    });
    await parentControls.start({
      height: 0,
    });
    axios.post('pushNotificationsMessage/markRead', { idsMessages: [notification.key] }, {
      headers: { Authorization: `Bearer ${auth.token}` },

    });

    verifyRead(item);
  };

  return (
  // Container da notificação
    <AnimationContainer
      animate={parentControls}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      isRead={isRead}
    >
      {/* ícone de notificação lida. Esse conteúdo vai aparecer quando a pessoa marcar como lida */}
      <motion.div
        animate={childrenControls}
        style={{
          opacity: 0,
          backgroundColor: '#537CCD',
          height: '100%',
          width: '100%',
          position: 'absolute',
          justifyContent: 'center',
          display: 'flex',
          alignItems: 'center',

        }}
      >
        <DraftsIcon style={{ color: '#FFF' }} fontSize="large" />
      </motion.div>

      {/* conteúdo normal da notificação, título, texto, botão de interação e o que mais que tiver que ter aqui */}
      <>
        <ListContent>
          <div >
            <MessageTitle>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {notification.title}
                { isRead && <div style={{
width: 6, height: 6, borderRadius: '50%', background: 'red', marginLeft: 5,
}}
                />
              }
              </div>

              { inHover && isRead ? <IconButton onClick={markAsRead}>
                <DraftsIcon style={{ color: '#000' }} fontSize="small" />
                                    </IconButton> : <div> <MessageDate>{notification.date}</MessageDate> </div>
         }
            </MessageTitle>

          </div>
          <MessageContent>{notification.text}</MessageContent>

        </ListContent>
      </>

    </AnimationContainer>
  );
}

